/**
 * Todo: Fix old IE warning, this is not working at the moment. Tested on IE8.
 */

if (document.all && !window.atob) {
  // Call .then otherwise the import promise never finalises and the
  // side-effects in the module are not executed.
  import('../topbar/browser-upgrade-warning/browser-upgrade-warning').then();
}

/**
 * Internet Explorer browser of versions 10 and older can be detected in JavaScript by checking existence of the
 * nonstandard document.all object available only in IE10 and older.
 *
 * document.addEventListener() was first implemented in IE9.
 *
 * Therefore document.all && !document.addEventListener checks whether we are in IE < 9.
 */
if (document.all && !document.addEventListener) {
  import('./isoldie').then((mod) => {
    mod.apply(document.getElementById('very-old-ie-browser-warning'));
  });
} else {
  // Remove empty div since we don't need it
  const elem = document.getElementById('very-old-ie-browser-warning');
  elem.parentNode.removeChild(elem);
}
